import { useCallback, useSyncExternalStore } from 'react';

// WHICH DIMENSION FIELD IS BEING TYPED INTO — read by the viewer above it, which draws that
// dimension's line whatever else is shown (see dimensionLines). The field and the viewer are in
// different components with a modal between them, so the fact is kept here, like partMarks.
//
// A NAME OR NOTHING. Not persisted: a focus is a caret, and it is gone the moment it leaves.
let focus: string | null = null;
const listeners = new Set<() => void>();

export const setDimensionFocus = (name: string | null): void => {
  if (name === focus) return;
  focus = name;
  listeners.forEach((l) => l());
};

export const useDimensionFocus = (): string | null => {
  const subscribe = useCallback((cb: () => void) => {
    listeners.add(cb);
    return () => { listeners.delete(cb); };
  }, []);
  return useSyncExternalStore(subscribe, () => focus);
};
